import { createSaveInProgressFormReducer } from 'platform/forms/save-in-progress/reducers';
import { healthEnrollmentStatusReducer } from 'platform/shared/health-apps';
import formConfig from '../config/form';
import { disabilityRatingReducer } from './disabilityRating';

export default {
  form: createSaveInProgressFormReducer(formConfig),
  healthEnrollmentStatus: healthEnrollmentStatusReducer,
  disabilityRating: disabilityRatingReducer,
};
